import { Node, mergeAttributes } from '@tiptap/core'

export default Node.create({
    name: "image",
    inline: true,
    group: "inline",
    draggable: true,
    addAttributes() {
        return {
            identifier: {
                default: undefined
            },
            src: {
                default: undefined,
                renderHTML: attributes => {
                    return {
                        src: attributes.src
                    }
                }
            },
            alt: {
                default: undefined
            },
            title: {
                default: undefined
            },
            size: {
                default: undefined,
                renderHTML: attributes => {
                    if (attributes.size) {
                        return {
                            style: "width: " + attributes.size + "px;height:auto;"
                        }
                    }
                }
            },
        }
    },
    renderHTML({ HTMLAttributes }) {
        return ["img", mergeAttributes(HTMLAttributes, { class: "rounded-2", style: "max-width:100%" })];
    },
    addCommands() {
        return {
            setImage: options => ({ commands }) => {
                return commands.insertContent({
                    type: this.name,
                    attrs: options
                });
            },
            setImageSize: (size) => ({ commands }) => {
                let attributes = JSON.parse(JSON.stringify(this.editor.getAttributes('image')));
                attributes.size = size;
                return commands.updateAttributes("image", attributes);
            },
        }
    }
});
